<template lang="pug">
div
  h1 联系我们
  p
    | 如果您在使用 PandaFan 的过程中遇到任何问题，建议您通过网站右下方的即时聊天系统或者工单联系我们。
  h2 电子邮件
  p.email
    | 我们的邮箱地址是： 
    a qhptt90l@pandafan-tech.intercom-mail.com
  p.email-notice
    | 注意：此邮箱仅用于接收邮件。我们的回复将通过 @pandafan-tech.intercom-mail.com、@1s.life 或 @beexio.com 发送。
  h2 邮寄地址
  p
    | Beexio B.V.
    br
    | Prof. J. H. Bavincklaan 2
    br
    | 1183 AT, Amstelveen
    br
    | The Netherlands
  //- h2 商务合作电话
  //- p
  //-   | 该号码为本公司商务合作专用，如果您有关于 PandaFan 的商务合作需求，请联系我们。
  //- p
  //-   | 其他关于 PandaFan 使用方面的问题，请使用即时聊天或工单联系客服。
  //- p
  //-   | (+31) 97010241866
  h2 其他信息
  p
    | PandaFan 是由 Beexio B.V. 及下属子公司提供的服务。
  p
    | 增值税号 NL862117720B01
    br
    | 荷兰商会注册编号 81502648
</template>
